import { render, staticRenderFns } from "./ViewFixedDeposit.vue?vue&type=template&id=4ae3edec&"
import script from "./ViewFixedDeposit.vue?vue&type=script&lang=js&"
export * from "./ViewFixedDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports